import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import { compose } from 'recompose'
import Summary from './Summary'
import AggregateTestReports from './AggregateTestReports'
import FileSection from 'containers/Project/NvqualFile/index'

class NvqualReport extends Component {
    render() {
        return(
          <div>
              <Summary {...this.props} />
              <AggregateTestReports {...this.props} />
              <FileSection {...this.props} />
          </div>
        )
    }
}

const withStyles = CSSModules(styles)
const enhance = compose(withStyles)
export default enhance(NvqualReport)
